import React from "react"
import { Link } from "gatsby"
import config from "../../config/config";

import style from "./index.module.css";

export default class Header extends React.Component {

  constructor(props) {
    super(props)
    this.handleClickMobileMenuOpen = this.handleClickMobileMenuOpen.bind(this);
    this.handleClickMobileMenuClose = this.handleClickMobileMenuClose.bind(this);
    this.handleClickMobileMenu = this.handleClickMobileMenu.bind(this);
    this.state = {
      mobileMenu: false,
    }
  }

  handleClickMobileMenuOpen(e) {
    e.preventDefault()
    this.setState({
      mobileMenu: true,
    })
  }

  handleClickMobileMenuClose(e) {
    e.preventDefault()
    this.setState({
      mobileMenu: false,
    })
  }

  handleClickMobileMenu(e) {
    this.setState({
      mobileMenu: false,
    })
  }

  render() {
    var menuClass = this.state.mobileMenu ? `${style.header} ${style.menuStateOpen}` : `${style.header}`;
    const dateChallengeClosed = new Date(config.challengeClosed);
    const dateVotingClosed = new Date(config.votingClosed);
    const dateVotingOpen = new Date(config.votingOpen);
    const dateNow = new Date();
    const challengeActive = dateNow < dateChallengeClosed;
    // const votingActive = (dateNow > dateVotingOpen) && (dateNow < dateVotingClosed);
    const votingActive = false;
    return (
      <div className={menuClass}>
        {challengeActive &&
          <div className={style.buttonContainer}>
            <Link className={style.button} to="/challenge/">Stuur je plan in</Link>
          </div>
        }
        {votingActive &&
          <div className={style.buttonContainer}>
            <Link className={style.button} to="/stemmen/">Stemmen</Link>
          </div>
        }
        <div className={style.background}>
          <Link className={style.logoContainer} to="/">
            <div className={style.logo} />
          </Link>
        </div>
        <div className={style.container}>
          <div className={style.menu} onClick={this.handleClickMobileMenu}>
            <div className={style.linkGroup}>
              <Link className={style.link} activeClassName={style.linkActive} partiallyActive={true} to="/challenge/"><span className={style.linkText}>Challenge</span></Link>
              <Link className={style.link} activeClassName={style.linkActive} partiallyActive={true} to="/inspiratie/"><span className={style.linkText}>Inspiratie</span></Link>
              <Link className={style.link} activeClassName={style.linkActive} partiallyActive={true} to="/events/"><span className={style.linkText}>Events</span></Link>
            </div>
            <div className={style.linkGroup}>
              <Link className={style.link} activeClassName={style.linkActive} partiallyActive={true} to="/green-deals/"><span className={style.linkText}>Green Deals</span></Link>
              <Link className={style.link} activeClassName={style.linkActive} partiallyActive={true} to="/initiatieven/"><span className={style.linkText}>Initiatieven</span></Link>
              <Link className={style.link} activeClassName={style.linkActive} partiallyActive={true} to="/partners/"><span className={style.linkText}>Partners</span></Link>
            </div>
          </div>
        </div>
        <div className={style.menuOpen} onClick={this.handleClickMobileMenuOpen}>
          <div className={style.circle}>Menu</div>
        </div>
        <div className={style.menuClose} onClick={this.handleClickMobileMenuClose}>
          <div className={style.circleAlt}>Close</div>
        </div>
      </div>
    )
  }
}